import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-text-sm" }

import { computed, ref } from "vue"
  import { QSelect } from "quasar"
  import { Countries } from "src/factories/data-factory";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CountrySelect',
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const countries = Countries;

  const props = __props

  const value = computed<string | null>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return null
      }
    },
    set(value: string | null) {
      emit('update:modelValue', value)
    }
  })

  const filteredCountries = ref(countries);
  function filterFn(val: string, update: Function) {
    if (val === '') {
      update(() => {
        filteredCountries.value = countries;
      })
      return
    }

    update(() => {
      const searchTerm = val.toLowerCase().replace(/ /g, "");
      filteredCountries.value = countries.filter(v =>
        !v ||
        (v.name.toLowerCase().replace(/ /g, "")).indexOf(searchTerm) > -1)
    })
  }

  const emit = __emit

  const countryRef = ref<QSelect | null>(null);
  function validate(){
    return countryRef.value!.validate();
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QSelect), {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    modelModifiers: { number: true },
    options: filteredCountries.value,
    ref_key: "countryRef",
    ref: countryRef,
    rules: [val => (__props.required === true && !!val) || !__props.required || 'Required'],
    "emit-value": "",
    "label-color": "tw-text-slate-500",
    class: _normalizeClass(!countryRef.value?.hasError ? 'tw-shadow-sm' : ''),
    "input-class": "tw-text-slate-500",
    "popup-content-class": "tw-text-sm tw-text-slate-500 limit-dd-height",
    "dropdown-icon": "mdi-chevron-down",
    label: value.value ? undefined : 'Select a country...',
    "map-options": "",
    "option-label": "name",
    "option-value": "name",
    "data-cy": "countrySelect",
    outlined: "",
    dense: "",
    autocomplete: "one-time-code",
    onFilter: filterFn,
    "use-input": "",
    "option-disable": val => val.code === '--'
  }, {
    selected: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(Countries).find(t => t.name === value.value)?.name), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "rules", "class", "label", "option-disable"]))
}
}

})